// 扫码类型(2入库1出库)
export enum WarehouseRecordTypeEnums {
  OUT = "1",
  IN = "2",
  BATCH_OUT = "6"
}

export const WarehouseRecordTypeMap: any = Object.freeze({
  [WarehouseRecordTypeEnums.IN]: "入库",
  [WarehouseRecordTypeEnums.OUT]: "出库",
  [WarehouseRecordTypeEnums.BATCH_OUT]: "出库" // 批量出库
});

// 0:异常待审核 1:已生效 2已退回,3已失效,4待确认
export enum WarehouseHistoryStatusEnums {
  WAIT_CHECK = 0,
  TOOK_EFFECT = 1,
  RETURNED = 2,
  INVALIDED = 3,
  WAIT_CONFIRM = 4
}

export const WarehouseHistoryStatusMap = Object.freeze({
  [WarehouseHistoryStatusEnums.WAIT_CHECK]: "审核中",
  [WarehouseHistoryStatusEnums.TOOK_EFFECT]: "已生效",
  [WarehouseHistoryStatusEnums.RETURNED]: "已退回",
  [WarehouseHistoryStatusEnums.INVALIDED]: "已失效",
  [WarehouseHistoryStatusEnums.WAIT_CONFIRM]: "待确认"
});

// 出入库搜索
export const WarehouseSearchRouteByRecordTypeMap = {
  [WarehouseRecordTypeEnums.IN]: "WarehouseInHistorySearch",
  [WarehouseRecordTypeEnums.OUT]: "WarehouseOutHistorySearch",
  [WarehouseRecordTypeEnums.BATCH_OUT]: "WarehouseBatchOutHistorySearch"
};

// 出入库搜索
export const WarehouseSearchRouteByRecordTypeMapOld = {
  [WarehouseRecordTypeEnums.IN]: "WarehouseInHistorySearchOld",
  [WarehouseRecordTypeEnums.OUT]: "WarehouseOutHistorySearchOld",
  [WarehouseRecordTypeEnums.BATCH_OUT]: "WarehouseBatchOutHistorySearchOld"
};

// 出入库类型(2026-02-03)
export enum ScanTypeEnums {
  OUT = "OUT",
  IN = "IN"
}
